'use client';
import React from 'react';
import { useRouter, usePathname } from '@/i18n/routing';
import { useLocale } from 'next-intl';
import { Select, Typography } from 'antd';
import 'dayjs/locale/th';
import 'dayjs/locale/en';
import dayjs from 'dayjs';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import { useTheme } from './ThemeComponents/ThemeProvider';

dayjs.extend(buddhistEra);

const { Text } = Typography;

const LocaleSwitcherTwo = () => {
  const router = useRouter();
  const pathname = usePathname();
  const locale = useLocale();
  const themeData = useTheme();
  const color1 = themeData?.theme?.calVariable?.primaryColor;

  const handleLocaleChange = (newLocale: string) => {
    if (newLocale !== locale) {
      router.replace({ pathname }, { locale: newLocale });
    }
    dayjs.locale(newLocale);
  };

  return (
    <div className="w-32">
      <Select
        value={locale}
        onChange={handleLocaleChange}
        style={{ width: '100%' }}
        options={[
          {
            value: 'en',
            label: (
              <Text style={{ color: locale === 'en' ? color1 : undefined }}>
                English
              </Text>
            ),
          },
          {
            value: 'th',
            label: (
              <Text style={{ color: locale === 'th' ? color1 : undefined }}>
                ไทย
              </Text>
            ),
          },
        ]}
      />
    </div>
  );
};

export default LocaleSwitcherTwo;
